var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"requests animate-slide-in-down app-container"},[_c(_setup.PageHeader,{attrs:{"title":_setup.getTitle()}}),_c(_setup.FormContainer,{attrs:{"title":'Tasas y primas',"data":_setup.formFields,"is-loading":_setup.isLoading.value,"actions":_setup.getActions(),"onBlur":_setup.handleBlur}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }